var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLeftArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 57,
    viewBox: "0 0 57 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M55.1185 28.3093C55.1185 43.1156 43.1156 55.1185 28.3093 55.1185C13.5029 55.1185 1.5 43.1156 1.5 28.3093C1.5 13.5029 13.5029 1.5 28.3093 1.5C43.1156 1.5 55.1185 13.5029 55.1185 28.3093Z",
    stroke: "currentColor",
    strokeWidth: 3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9894 30.6326C11.066 29.5221 11.066 26.746 12.9894 25.6356L28.1357 16.8908C30.0591 15.7804 32.4633 17.1684 32.4633 19.3893V36.8789C32.4633 39.0997 30.0591 40.4877 28.1357 39.3774L12.9894 30.6326Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M41.6719 24.8828H22.355C20.5625 24.8828 19.1094 26.3359 19.1094 28.1285C19.1094 29.921 20.5625 31.3741 22.355 31.3741H41.6719C43.4644 31.3741 44.9175 29.921 44.9175 28.1285C44.9175 26.3359 43.4644 24.8828 41.6719 24.8828Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftArrow);
export default __webpack_public_path__ + "static/media/left-arrow.ef41a5b18f9aceea3cdb2525324e47a3.svg";
export { ForwardRef as ReactComponent };